import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import Empty from '../Icons/Empty';

export interface EmptyTableProps {
  text: string;
  width?: string;
}

const EmptyTable: React.FC<EmptyTableProps> = ({ text, width }) => {
  const useStyles = makeStyles()({
    emptyCard: {
      margin: '2rem',
      width: width ?? '365px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      gap: '2rem',
    },
  });
  const { classes } = useStyles();
  return (
    <Grid className={classes.emptyCard}>
      <Empty />
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        align="center"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
      >
        {text}
      </Typography>
    </Grid>
  );
};

export default EmptyTable;
